export default "__VITE_ASSET__qkf51TQj__"